import request from "@/utils/request.js";
import { teachingPlatformApi } from "@/config/deploy.js";

/**
 * 详情
 * @param params
 * @returns {AxiosPromise}
 */
export function get(params) {
  return request({
    url: teachingPlatformApi + "/app/cq/standardized/training/manual/get",
    method: "post",
    data: params
  });
}

/**
 * 列表
 * @param params
 * @returns {AxiosPromise}
 */
export function recordList(params) {
  return request({
    url: teachingPlatformApi + "/app/cq/standardized/training/manual/list",
    method: "post",
    data: params
  });
}

/**
 * 保存
 * @param params
 * @returns {AxiosPromise}
 */
export function save(params) {
  return request({
    url: teachingPlatformApi + "/app/cq/standardized/training/manual/save",
    method: "post",
    data: params
  });
}

/**
 * 修改
 * @param params
 * @returns {AxiosPromise}
 */
export function update(params) {
  return request({
    url: teachingPlatformApi + "/app/cq/standardized/training/manual/update",
    method: "post",
    data: params
  });
}

//全部方法
//get、list、save、update
